/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TrackingMultiUserResponse } from '../models/TrackingMultiUserResponse';
import type { TrackingSingleUserResponse } from '../models/TrackingSingleUserResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TrackingV2Service {
    /**
     * Retrieves tracking data by creator
     * Retrieves the accumulated tracking data of all browsers of a creator.
     * All data in the given timestamp range is accumulated by the browser's name.
     *
     * @returns TrackingMultiUserResponse The requested tracking data
     * Please note that not every day between the specified `from` and `to` date
     * must be in the `revenues` object.
     *
     * @throws ApiError
     */
    public static findTrackingDataByCreator({
        creatorId,
        from,
        to,
    }: {
        /**
         * Id of the creator.
         */
        creatorId: number,
        /**
         * The start date of the period. Must not be after `to`
         */
        from: string,
        /**
         * The end date of the period
         */
        to: string,
    }): CancelablePromise<TrackingMultiUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/creator/{creatorId}/tracking',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                403: `The user is not authorized for this creator
                (not owner or team member with admin privileges)
                or the creator has not the required license plan.
                `,
            },
        });
    }
    /**
     * Get creator's tracking data for a specific user
     * Returns tracking data for a specific creator and user within a date range.
     * @returns TrackingSingleUserResponse Tracking data successfully retrieved
     * @throws ApiError
     */
    public static findTrackingDataByUser({
        creatorId,
        userId,
        start,
        end,
        hourly = false,
    }: {
        /**
         * ID of the creator
         */
        creatorId: number,
        /**
         * ID of the target user whose tracking data is requested
         */
        userId: number,
        /**
         * Start date of the tracking period (inclusive)
         */
        start: string,
        /**
         * End date of the tracking period (inclusive)
         */
        end: string,
        /**
         * Return data with hourly resolution if true
         */
        hourly?: boolean,
    }): CancelablePromise<TrackingSingleUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/creator/{creatorId}/tracking/user/{userId}',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'start': start,
                'end': end,
                'hourly': hourly,
            },
            errors: {
                403: `Forbidden access to creator or user data`,
            },
        });
    }
    /**
     * Get creator's tracking data by browser
     * Returns tracking data for a specific creator filtered by browser name and date range.
     * @returns TrackingSingleUserResponse Successful response
     * @throws ApiError
     */
    public static findTrackingDataByBrowser({
        creatorId,
        browserName,
        start,
        end,
        hourly = false,
    }: {
        /**
         * ID of the creator
         */
        creatorId: number,
        /**
         * Browser name
         */
        browserName: string,
        /**
         * Start date of the tracking period
         */
        start: string,
        /**
         * End date of the tracking period
         */
        end: string,
        /**
         * Return data in hourly resolution if true
         */
        hourly?: boolean,
    }): CancelablePromise<TrackingSingleUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/creator/{creatorId}/tracking/browser/{browserName}',
            path: {
                'creatorId': creatorId,
                'browserName': browserName,
            },
            query: {
                'start': start,
                'end': end,
                'hourly': hourly,
            },
            errors: {
                403: `Forbidden access`,
            },
        });
    }
    /**
     * Get leaderboard tracking data V2
     * Returns tracking data for multiple creators between the specified dates.
     * @returns TrackingMultiUserResponse Successful response
     * @throws ApiError
     */
    public static findLeaderboard({
        from,
        to,
        creatorIds,
    }: {
        /**
         * The start date of the period. Must not be after `to`
         */
        from: string,
        /**
         * The end date of the period
         */
        to: string,
        /**
         * List of creator IDs to include in the leaderboard. Can be repeated in query like: `?creatorIds=1&creatorIds=2`.
         */
        creatorIds: Array<number>,
    }): CancelablePromise<TrackingMultiUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/creator/leaderboard',
            query: {
                'from': from,
                'to': to,
                'creatorIds': creatorIds,
            },
            errors: {
                403: `Forbidden access`,
            },
        });
    }
    /**
     * Get leaderboard tracking data by user
     * Returns aggregated tracking data across multiple creators for a specific user and date range.
     * @returns TrackingSingleUserResponse Successfully retrieved leaderboard data
     * @throws ApiError
     */
    public static findLeaderboardDataByUser({
        userId,
        from,
        to,
        creatorIds,
        hourly = false,
    }: {
        /**
         * ID of the target user
         */
        userId: number,
        /**
         * Start date of the tracking period
         */
        from: string,
        /**
         * End date of the tracking period
         */
        to: string,
        /**
         * List of creator IDs to include in the leaderboard
         */
        creatorIds: Array<number>,
        /**
         * Return data with hourly resolution if true
         */
        hourly?: boolean,
    }): CancelablePromise<TrackingSingleUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/creator/leaderboard/user/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'from': from,
                'to': to,
                'creatorIds': creatorIds,
                'hourly': hourly,
            },
            errors: {
                403: `Forbidden access to one or more creators`,
            },
        });
    }
    /**
     * Get leaderboard tracking data by browser
     * Returns aggregated tracking data across multiple creators for a specific browser and date range.
     * @returns TrackingSingleUserResponse Successfully retrieved leaderboard data
     * @throws ApiError
     */
    public static findLeaderboardDataByBrowser({
        browserName,
        from,
        to,
        creatorIds,
        hourly = false,
    }: {
        /**
         * Browser name
         */
        browserName: string,
        /**
         * Start date of the tracking period
         */
        from: string,
        /**
         * End date of the tracking period
         */
        to: string,
        /**
         * List of creator IDs to include in the leaderboard
         */
        creatorIds: Array<number>,
        /**
         * Return data with hourly resolution if true
         */
        hourly?: boolean,
    }): CancelablePromise<TrackingSingleUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v2/creator/leaderboard/browser/{browserName}',
            path: {
                'browserName': browserName,
            },
            query: {
                'from': from,
                'to': to,
                'creatorIds': creatorIds,
                'hourly': hourly,
            },
            errors: {
                403: `Forbidden access to one or more creators`,
            },
        });
    }
}
